import React from 'react';

import { DropdownInput, extraSmallGroupIcon, safeParseHtml } from '../../../../Shared/index';

const studentsButton = ({ buttonGroupCallback, }) => {
  const identifier = 'students'
  const active = window.location.href.includes(identifier) || window.location.href.includes('student_report')
  const handleClick = () => buttonGroupCallback(identifier)
  return <button aria-current={active ? 'page' : undefined} className='focus-on-light' onClick={handleClick} type="button">Student reports</button>
}

const questionsButton = ({ buttonGroupCallback, }) => {
  const identifier = 'questions'
  const active = window.location.href.includes(identifier)
  const handleClick = () => buttonGroupCallback(identifier)
  return <button aria-current={active ? 'page' : undefined} className='focus-on-light' onClick={handleClick} type="button">Question reports</button>
}

const Navbar = ({ params, selectedActivity, classrooms, buttonGroupCallback, dropdownCallback, }) => {
  const classroomOptions = classrooms.map(classroom => ({ value: classroom.id, label: classroom.name, }))

  const onDropdownChange = (classroomOption) => {
    const selectedClassroom = classrooms.find(c => c.id === classroomOption.value)
    dropdownCallback(selectedClassroom)
  }

  return (
    <header className="reports-header">
      <div className="container">
        <div className="name-and-classroom-dropdown">
          <h1>{safeParseHtml(selectedActivity.name)}</h1>
          <DropdownInput
            ariaLabel="Classroom"
            className="bordered small focus-on-light"
            customMenuIconUrl={extraSmallGroupIcon.src}
            handleChange={onDropdownChange}
            id="classroom-dropdown"
            options={classroomOptions}
            value={classroomOptions.find(opt => String(opt.value) === params.classroomId)}
          />
        </div>
        <nav>
          <ul>
            <li>{studentsButton({ buttonGroupCallback, })}</li>
            <li>{questionsButton({ buttonGroupCallback, })}</li>
          </ul>
        </nav>
      </div>
    </header>
  )
}

export default Navbar
